/**
 * Interface para serviços de storage
 */

import { BasePlatformService } from './base_platform_service';

export enum StorageType {
  LOCAL = 'localStorage',
  SESSION = 'sessionStorage',
  INDEXED_DB = 'indexedDB',
  CACHE = 'cacheStorage',
  MEMORY = 'memory'
}

export interface StorageOptions {
  encrypt?: boolean;
  compress?: boolean;
  ttl?: number;
  prefix?: string;
}

export interface StorageItem<T = any> {
  data: T;
  timestamp: number;
  ttl?: number;
  version?: string;
}

export interface StorageInfo {
  available: boolean;
  used?: number;
  total?: number;
  remaining?: number;
}

export interface IStorageService extends BasePlatformService {
  readonly serviceName: 'Storage';
  
  isAvailable(type: StorageType): boolean;
  getBestAvailable(preferred?: StorageType[]): StorageType;
  setItem<T>(key: string, value: T, type?: StorageType, options?: StorageOptions): Promise<boolean>;
  getItem<T>(key: string, type?: StorageType, options?: StorageOptions): Promise<T | null>;
  removeItem(key: string, type?: StorageType, options?: StorageOptions): Promise<boolean>;
  clear(type?: StorageType, options?: StorageOptions): Promise<boolean>;
  getKeys(type?: StorageType, options?: StorageOptions): Promise<string[]>;
  hasItem(key: string, type?: StorageType, options?: StorageOptions): Promise<boolean>;
  getStorageInfo(type?: StorageType): Promise<StorageInfo>;
}
